import { render, staticRenderFns } from "./bid-row.vue?vue&type=template&id=5147a98b&scoped=true"
import script from "./bid-row.vue?vue&type=script&lang=js"
export * from "./bid-row.vue?vue&type=script&lang=js"
import style0 from "./bid-row.vue?vue&type=style&index=0&id=5147a98b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147a98b",
  null
  
)

export default component.exports